import "../i18n";
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Sentry } from "../sentryInstrumentReact";

import ProcessingSpinner from '../components/ProcessingSpinner';
import { defaultProductUi, updateProductUi } from './storeLogic/storeStateManager';


function AddToCart({productId}) {
  const [productInfo, setProductInfo] = useState({});
  const [productUi, setProductUi] = useState(defaultProductUi);
  const [loading, setLoading] = useState(true);
  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const csrftoken = Cookies.get('csrftoken');
  const cleanFullPrice = parseFloat(productUi.fullPrice).toFixed(2);
  const cleanSalePrice = parseFloat(productUi.salePrice).toFixed(2);
  let percentSavings = null;
  let displayLowQtyMessage = null;
  if (productUi.fullPrice > productUi.salePrice) {
    percentSavings = parseFloat(((cleanFullPrice - cleanSalePrice) / cleanFullPrice) * 100).toFixed(0);
  }
  if (parseInt(productInfo.quantity) < 10 && parseInt(productInfo.quantity) > 0) {
    displayLowQtyMessage = true;
  }
  const maxiumQty = productInfo.maximum_quantity || 9999;
  const backorderQty = productUi.quantity + productInfo.quantity_in_cart - productInfo.quantity;
  

  useEffect(() => {
    async function fetchProductInfo() {
      try {
        const response = await fetch(`/store/_api/products/${productId}/`, {
          method: 'GET',
          headers: {"Content-Type": "application/json"},
        });

        // fixme: is this proper for throwing error?
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setProductInfo(data);
        const minQuantityAtLoad = data.quantity_in_cart >= data.minimum_quantity ? 1 : data.minimum_quantity;
        setProductUi(prevProductUi => updateProductUi(data, minQuantityAtLoad, prevProductUi));
        
      } catch (error) {
		if (Sentry && Sentry.getClient()) {
          Sentry.captureException(error, {stage: "error retrieving data from API"});
		}
      }
      setLoading(false);

    }
    fetchProductInfo();
  }, []);


  function onChangeHandler(event) {
    setProductUi(updateProductUi(productInfo, event.target.value, productUi));
  }


  function onClickHandler(changeAmt) {
    setProductUi(updateProductUi(productInfo, parseInt(productUi.quantity) + changeAmt, productUi));
  }


  async function addToCartOnClickHandler() {
    setAddToCartLoading(true);
    try {
      const response = await fetch("/store/_api/cart/", {
        method: "POST",
        headers: {"Content-Type": "application/json", "X-CSRFToken": csrftoken},
        body: JSON.stringify({product: productInfo.id, quantity: productUi.quantity}),
      })

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }

      window.location.href = window.gettext("/store/cart/");

    } catch (error) {
      const values = Object.values(error);
      setAddToCartLoading(false);
      setProductUi(prevProductUi => {
        return {
          ...prevProductUi,
          errors: values,
        }
      });
       
    }
  }



  if(loading) {
    return (
      <ProcessingSpinner />
    );
  }

  return (
    <>
      {percentSavings === null ? (
        <p className="price mt-1"><strong className="normal-price no-sale">${cleanSalePrice}</strong></p>
      ) : (
        <p className="price mt-1 mb-1">
          <strong className="sale-price">${cleanSalePrice}</strong> 
          <strike className="normal-price">{cleanFullPrice}</strike> 
          <span className="savings">{window.gettext("Save")} {percentSavings}%</span>
        </p> 
      )}
          
      {(productInfo.quantity_break_ranges?.length || 0) > 0 &&
        <table className="table table-bordered table--quantity-discounts mb-1">
          <thead>
            <tr>
              <th>{window.gettext("Quantity")}</th>
              {productInfo.quantity_break_ranges.map(range => 
                <th>{range}</th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{window.gettext("Price per item")}</th>
              {productInfo.quantity_break_prices.map(price => 
                <td>${price.toFixed(2)}</td>
              )}
            </tr>
          </tbody>
        </table>
      }

      {displayLowQtyMessage &&
        <p className="low-stock">
          {window.gettext("Only ") + productInfo.quantity + window.gettext(" left in stock–order soon.")}
        </p>
      }
      {productUi.canAddMore === false ? (
        <p className="alert alert-warning">{window.gettext("Max quantity: ") + productInfo.maximum_quantity + window.gettext(". You cannot add any more of this resource to your cart.")}</p>
      ) : (
        <div className="cart-actions" method="post">
          <div className="cart-counter">
            <button className="minus cart-btn" id="btn-quantity-down" disabled={productUi.minusDisabled} onClick={() => onClickHandler(-1)}>
              <svg viewBox="0 0 24 24" fill="currentColor" height="16px" width="16px" className="icon icon--counter">
                <path d="M17 11a1 1 0 010 2H7a1 1 0 010-2h10z">
                </path>
              </svg>
            </button>
            <input 
              type="number" 
              min={productInfo.minimum_quantity} 
              max={maxiumQty} 
              id="quantity" 
              pattern="[0-9]*" 
              className="qty text" 
              aria-label="Product quantity" 
              size="4" 
              step="1" 
              placeholder="" 
              autocomplete="off" 
              value={productUi.quantity} 
              onChange={onChangeHandler}
              readOnly={productInfo.maximum_quantity === 1}
            />
            <button className="plus cart-btn" id="btn-quantity-up" disabled={productUi.plusDisabled} onClick={() => onClickHandler(1)}>
              <svg fill="currentColor" viewBox="0 0 16 16" height="16px" width="16px" className="icon icon--counter">
                <path d="M8 4a.5.5 0 01.5.5v3h3a.5.5 0 010 1h-3v3a.5.5 0 01-1 0v-3h-3a.5.5 0 010-1h3v-3A.5.5 0 018 4z">
                </path>
              </svg>
            </button>
          </div>
          {addToCartLoading === true ? (
            <ProcessingSpinner />
          ) : (
            <a id="add-to-cart-btn" className="btn btn-primary btn-spotlight" onClick={addToCartOnClickHandler}>{window.gettext("Add to Cart")}</a>
          )}
        </div>
      )}

      {productUi.backorder && 
        <div>
          {productInfo.quantity === 0 ? 
            <>
              <p className="alert alert-warning">
                {window.gettext("This item is on backorder. You can pay now and we will ship the entire order as soon as all resources are available in our warehouse.")} 
              </p>
            </>
          : 
            <>
              <p className="alert alert-warning">
                {window.gettext("Quantity available now: ") + productInfo.quantity}<br />
                {window.gettext("Quantity to put on backorder: ") + backorderQty}<br />
                {window.gettext("You can pay now and we will ship the entire order as soon as all resources are available in our warehouse.")}  
              </p>
            </>
          }
        </div>
      }
      
      {!addToCartLoading && productUi.errors.length > 0 && 
        <div className="messages-wrapper" style={{maxWidth: "var(--narrow)", marginInline: "auto"}}>
          <ul className="messages list-unstyled">
            {productUi.errors.map(error => (
              <li className="alert alert-warning">{error}</li>
            ))}
          </ul>
        </div>
      }
    </>
  )
}

export default AddToCart;
